import React, { useEffect, useState } from 'react'

import Drawer from '@material-ui/core/Drawer'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'

import * as yup from 'yup'
import { validateSchema } from 'helpers/schemaValidation'

import { FormTitle } from 'components/Maintainance/components'
import { Toast } from 'Snackbar/useToast'
import { MinimalInput, MinimalPhoneInput } from 'components/Assets/components'
import { snakifyKeys } from 'helpers/formatters'
import facilities from 'Services/facilities'

function AddContact({ open, onClose, reFetch, obj, isEdit, clientCompanyId }) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState({})
  const [sitecontactTitle, setSiteContactTitle] = useState('')
  const [sitecontactName, setSiteContactName] = useState('')
  const [sitecontactEmail, setSiteContactEmail] = useState('')
  const [sitecontactPhone, setPhoneNumber] = useState('')

  const validateForm = async () => {
    const schema = yup.object().shape({
      sitecontactTitle: yup.string().required('Contact Title is required !'),
      sitecontactName: yup.string().required('Contact Name is required !'),
      sitecontactEmail: yup.string().email('Enter a valid Email !').required('Email is required !'),
      sitecontactPhone: yup.string().nullable(),
    })

    const payload = {
      clientCompanyId,
      sitecontactTitle,
      sitecontactName,
      sitecontactEmail,
      sitecontactPhone,
      sitecontactId: isEdit && obj ? obj.sitecontactId : null,
    }
    const isValid = await validateSchema(payload, schema)
    setError(isValid)
    if (isValid === true) submitData(payload)
  }

  const submitData = async payload => {
    setIsLoading(true)
    try {
      const res = await facilities.addUpdateSiteContact(snakifyKeys(payload))
      if (res.success > 0) {
        if (isEdit && obj) {
          Toast.success('Contact details have been updated successfully!')
        } else {
          Toast.success('Contact details have been created successfully!')
        }
      } else Toast.error(res.message)
    } catch (error) {
      console.log(error)
      Toast.error('Something went wrong !')
    }
    setIsLoading(false)
    onClose()
    reFetch()
  }

  useEffect(() => {
    if (isEdit && obj) {
      setSiteContactTitle(obj.sitecontactTitle ? obj.sitecontactTitle : '')
      setSiteContactName(obj.sitecontactName ? obj.sitecontactName : '')
      setSiteContactEmail(obj.sitecontactEmail ? obj.sitecontactEmail : '')
      setPhoneNumber(obj.sitecontactPhone ? obj.sitecontactPhone : '')
    }
  }, [])

  return (
    <Drawer anchor='right' open={open} onClose={onClose} style={{ width: '100%' }}>
      <FormTitle title={`${isEdit ? 'Edit' : 'Create'} Facility Contact`} closeFunc={onClose} style={{ width: '100%' }} />
      <div style={{ padding: '10px', height: 'calc(100vh - 65px)', width: '450px', background: '#efefef' }}>
        <div style={{ padding: '16px', background: '#fff', borderRadius: '4px' }}>
          <MinimalInput value={sitecontactTitle} onChange={setSiteContactTitle} error={error.sitecontactTitle} label='Contact Title' placeholder='Enter Contact Title' w={100} onFocus={() => setError({ ...error, sitecontactTitle: null })} />
          <MinimalInput value={sitecontactName} onChange={setSiteContactName} error={error.sitecontactName} label='Contact Name' placeholder='Enter Contact Name' w={100} onFocus={() => setError({ ...error, sitecontactName: null })} />
          <MinimalInput value={sitecontactEmail} onChange={setSiteContactEmail} error={error.sitecontactEmail} label='Contact Email' placeholder='Enter Contact Email' w={100} onFocus={() => setError({ ...error, sitecontactEmail: null })} />
          <MinimalPhoneInput value={sitecontactPhone} onChange={setPhoneNumber} error={error.sitecontactPhone} label='Contact Phone' placeholder='Enter Contact Phone' onFocus={() => setError({ ...error, sitecontactPhone: null })} w={100} />
        </div>
      </div>
      <div className='d-flex justify-content-between align-items-center' style={{ borderTop: '1px solid #A6A6A6', borderBottom: 'none', background: '#fff', marginTop: 'auto', padding: '12px' }}>
        <Button variant='contained' color='default' className='nf-buttons' disableElevation onClick={onClose}>
          Cancel
        </Button>
        <Button variant='contained' color='primary' className='nf-buttons' onClick={validateForm} disableElevation disabled={isLoading}>
          {isLoading ? (isEdit ? 'Updating...' : 'Adding...') : isEdit ? 'Update' : 'Add'}
          {isLoading && <CircularProgress size={20} thickness={5} style={{ color: '#fff', marginLeft: '10px' }} />}
        </Button>
      </div>
    </Drawer>
  )
}

export default AddContact
